import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, withRouter } from 'react-router';
import * as actions from '../../store/actions/authActions';
import HomeScreen from './HomeScreen';

const Home = () => {
    const auth = useSelector(state => state.auth);
    const userProfile = useSelector(state => state.profile.userProfile);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.authCheckState());
    }, [auth.user,dispatch]);

    return (
        <Fragment>
            {auth.user !== null && userProfile !== null ? <HomeScreen /> : <Redirect to="/account" /> }
        </Fragment>
    );
};

export default withRouter(Home);